import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { WarehouseLocationsDataGrid } from "src/components/views/erp/warehouse/masterData/WarehouseLocationsDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/warehouse/warehouseLocations")({
	staticData: { title: i18n.t("warehouse_locations"), legacyViewKey: "warehouseLocationsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <WarehouseLocationsDataGrid />;
}
